const toStr = Object.prototype.toString;

/**
 * @param {any} obj
 * @param {string} type
 */
const isType = (obj, type) => toStr.call(obj) === `[object ${type}]`;

/**
 * @param {any} obj
 */
const getType = obj => toStr.call(obj).slice(8, -1).toLowerCase();

/**
 * Shout-out to AngusCroll (https://goo.gl/pxwQGp)
 *
 * @param {any} obj
 */
export const toType = (obj) => {
	if (obj === null || obj === undefined) {
		return `${obj}`;
	}
	return toStr.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};

/**
 * Kudos to sindresorhus
 * @link https://github.com/sindresorhus/is-plain-obj
 *
 * @param {any} value
 */
export const isPlainObject = (value) => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
export const isObject = obj => ((obj && typeof obj === 'object' && obj.constructor === Object) ? true : false);
export const isEmptyObject = (/** @type {any} */ obj) => {
	let name;
	// eslint-disable-next-line guard-for-in, no-unreachable-loop
	for (name in obj) {
		return false;
	}
	return true;
};
// export const isEmptyPlainObject = obj => isObject(obj) && Object.keys(obj).length === 0;
export const isEmptyPlainObject = obj => (obj ? (isEmptyObject(obj) && isPlainObject(obj)) : false);
export const isArray = (/** @type {any} */ obj) => obj && typeof obj === 'object' && obj.constructor === Array;
export const isFunction = (/** @type {any} */ obj) => obj && typeof obj === 'function';
export const isString = (/** @type {any} */ obj) => obj && typeof obj === 'string';
export const isNumber = (/** @type {any} */ obj) => obj && typeof obj === 'number';
export const isBoolean = (/** @type {any} */ obj) => obj && typeof obj === 'boolean';
export const isUndefined = (/** @type {any} */ obj) => obj === undefined;
export const isNull = (/** @type {any} */ obj) => obj === null;
export const isNullOrUndefined = (/** @type {any} */ obj) => obj === null || obj === undefined;
export const isPrimitive = (/** @type {any} */ obj) => isString(obj) || isNumber(obj) || isBoolean(obj) || isNullOrUndefined(obj);
export const isIterable = (/** @type {any} */ obj) => obj && typeof obj[Symbol.iterator] === 'function';
export const isAsyncIterable = (/** @type {any} */ obj) => obj && typeof obj[Symbol.asyncIterator] === 'function';
export const isGenerator = (/** @type {any} */ obj) => obj && typeof obj.next === 'function' && typeof obj.throw === 'function';
export const isGeneratorFunction = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'GeneratorFunction';
export const isAsyncFunction = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'AsyncFunction';
export const isPromise = (/** @type {any} */ obj) => obj && typeof obj.then === 'function';
export const isRegExp = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'RegExp';
export const isDate = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'Date';
export const isMap = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'Map';
export const isSet = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'Set';
export const isWeakMap = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'WeakMap';
export const isWeakSet = (/** @type {any} */ obj) => obj && obj.constructor && obj.constructor.name === 'WeakSet';
export const isSymbol = (/** @type {any} */ obj) => obj && typeof obj === 'symbol';
